import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';

import Content from '../../../common/template/content';
import ContentCard from '../../../common/template/contentCard';
import ContentCardHeader from '../../../common/template/contentCardHeader';
import ContentCardBody from '../../../common/template/contentCardBody';
import Row from '../../../common/layout/row';
import Grid from '../../../common/layout/grid';
import Table from '../../../common/table/table';
import THead from '../../../common/table/tHead';
import Tr from '../../../common/table/tr';
import Th from '../../../common/table/th';
import TBody from '../../../common/table/tBody';
import Td from '../../../common/table/td';
import ButtonTable from '../../../common/table/buttonTable';
import Button from '../../../common/button/button';
import Form from './safraManejoProdutoForm';
import imagemSoLogo from '../../../assets/images/sologo.png';
import FormatUtils from '../../../common/formatUtils/FormatUtils';
import DateFormat from '../../../common/dateFormat/DateFormat';

import {
	setModoTela, initForm, salvar, excluir, getLista
} from './safraManejoProdutoActions';

class SafraManejoProduto extends Component {

	state = {
		linhaSelecionada: null
	}

    componentWillMount() {
        this.props.getLista(this.props.registroSafraManejo.id);
		this.props.setModoTela('lista');
    }

    render() {
        return (
            <div>

				{this.props.aguardando ? (
					<div class='modal fade show' id='modal-overlay' style={{ display: 'block', paddingRight: 15 }} aria-modal='true' role='dialog'>
						<div class='modal-dialog'>
							<div class='overlay'>
								<div style={{ marginLeft: '50%', marginRight: '50%' }}>
									<img src={imagemSoLogo} style={{ height: 40, width: 40, marginBottom: -76, marginLeft: 8 }} />
								</div>
								<i class='fas fa-4x fa-spinner fa-spin' style={{ marginLeft: '50%', marginRight: '50%' }}></i>
							</div>
						</div>
					</div>
				) : null}

                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<ContentCardHeader>
					<label>Produtos</label>
				</ContentCardHeader>
				<ContentCardHeader>
					<Row>
						{(this.props.registroSafraManejo.tipos || []).map(idTipo => {
							let tipo = this.props.listaTipo.filter(tipo => tipo.id == idTipo)[0];
							if (tipo) {
								return (
									<Grid cols='6 6 4 2'>
										<Button
											text={`Adicionar ${tipo.valor}`}
											type={'success'}
											icon={'fa fa-plus'}
											event={() => {
												this.props.setModoTela('cadastro', { id_safra_manejo: this.props.registroSafraManejo.id, id_tipo: idTipo });
												this.props.initForm({ id_safra_manejo: this.props.registroSafraManejo.id, id_tipo: idTipo });
											}} />
									</Grid>
								);
							}
						})}
						<Grid cols='6 6 4 2'>
							<Button
								text='Adicionar Outros'
								type={'success'}
								icon={'fa fa-plus'}
								event={() => {
									this.props.setModoTela('cadastro', { id_safra_manejo: this.props.registroSafraManejo.id });
									this.props.initForm({ id_safra_manejo: this.props.registroSafraManejo.id });
								}} />
						</Grid>
					</Row>
				</ContentCardHeader>
				<ContentCardBody>
					<Table responsive>
						<THead>
							<Tr>
								<Th>Tipo</Th>
								<Th>Tipo de Produto</Th>
								<Th>Produto/Fórmula</Th>
								<Th alignRight>Dose (hectare)</Th>
								<Th></Th>
								<Th alignRight>Custo (hectare)</Th>
								<Th></Th>
							</Tr>
						</THead>
						<TBody>
							{this.props.lista.map(item => (
								<Tr key={item.id} className={`${this.state.linhaSelecionada == item.id ? 'hover' : ''}`}
									onClick={() => this.setState({ ...this.state, linhaSelecionada: item.id })}
									onMouseEnter={() => this.setState({ ...this.state, linhaSelecionada: item.id })} >
									<Td>{item.nome_tipo || 'Outros'}</Td>
									<Td>{item.nome_produto_tipo }</Td>
									<Td>{item.nome_produto || item.formula}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.dose, 4)}</Td>
									<Td>{item.nome_unidade_medida}</Td>
									<Td alignRight>{FormatUtils.formatarValorTela(item.custo, 2)}</Td>
									<Td alignRight minWidth={100}>
										<ButtonTable
											type={'warning'}
											icon={'fas fa-pencil-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('cadastro', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />

										<ButtonTable
											type={'danger'}
											icon={'fas fa-trash-alt'}
											visible={this.state.linhaSelecionada == item.id}
											event={() => {
												this.props.setModoTela('exclusao', {
													...item
												});
												this.props.initForm({
													...item
												});
											}} />
									</Td>
								</Tr>
							))}
						</TBody>
					</Table>
				</ContentCardBody>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.safraManejoProduto.modoTela,
	lista: state.safraManejoProduto.lista,
	aguardando: state.safraManejoProduto.aguardando,
	registroSafraManejo: state.safraManejo.registro,
	listaTipo: state.safraManejo.listaTipo
});
const mapDispatchToProps = dispatch => bindActionCreators({
	setModoTela, initForm, salvar, excluir, getLista
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SafraManejoProduto);
